import { boot } from 'quasar/wrappers'
import { constants } from 'src/js/constants.js';
export default boot(({ app }) => {
    app.config.globalProperties.$constants = constants
});